import { Route } from '@angular/router';
import { Role } from '@perval/shared';
import { ConsumptionTrackingContainer } from './consumption_tracking/pages/consumption-tracking.container';
import { DashboardContainer } from './dashboard/pages/dashboard.container';
import { FeatureFlipping } from './guards/feature-flipping.guard';
import { RoleGuard } from './guards/role.guard';
import { ManageApiContainer } from './manage-api/pages/manage-api.container';
import { ManageClientsContainer } from './manage-clients/pages/manage-clients.container';
import { ManageUsersContainer } from './manage-users/pages/manage-users.container';

export const adminRoutes: Route[] = [
  {
    path: 'admin',
    component: DashboardContainer,
    canActivate: [RoleGuard, FeatureFlipping],
    data: {
      expectedRole: [
        Role.ADMIN_XNOTACCOUNT_CREATE,
        Role.ADMIN_CONSUMPTIONTRACKING_EXPORT,
      ],
    },
  },
  {
    path: 'admin/manage-clients',
    component: ManageClientsContainer,
    canActivate: [RoleGuard, FeatureFlipping],
    data: {
      expectedRole: [Role.ADMIN],
    },
  },
  {
    path: 'admin/manage-users',
    component: ManageUsersContainer,
    canActivate: [RoleGuard, FeatureFlipping],
    data: {
      expectedRole: [Role.ADMIN_XNOTACCOUNT_CREATE],
      redirectTo: 'admin',
    },
  },
  {
    path: 'admin/consumption-tracking',
    component: ConsumptionTrackingContainer,
    canActivate: [RoleGuard, FeatureFlipping],
    data: {
      expectedRole: [Role.ADMIN_CONSUMPTIONTRACKING_EXPORT],
      redirectTo: 'admin',
    },
  },
  {
    path: 'admin/manage-api',
    component: ManageApiContainer,
    canActivate: [RoleGuard, FeatureFlipping],
    data: {
      expectedRole: [Role.ADMIN],
    },
  },
];
